import { defaultOpts } from './defaults';
export * from './types';
export function createColorTheme() {
  var partialOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var builders = Object.assign(Object.assign({}, defaultOpts), partialOpts);
  return {
    light: createColorScheme(builders, false),
    dark: createColorScheme(builders, true)
  };
}

function createColorScheme(opts, dark) {
  return {
    default: createColor(opts, dark, 'default'),
    transparent: createColor(opts, dark, 'transparent'),
    primary: createColor(opts, dark, 'primary'),
    positive: createColor(opts, dark, 'positive'),
    caution: createColor(opts, dark, 'caution'),
    critical: createColor(opts, dark, 'critical')
  };
}

function createColor(opts, dark, name) {
  var base = opts.base({
    dark: dark,
    name: name
  });
  var solid = {
    default: {
      enabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.solid({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.solid({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'pressed'
      }),
      selected: opts.solid({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'selected'
      })
    },
    transparent: {
      enabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.solid({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.solid({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'pressed'
      }),
      selected: opts.solid({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'selected'
      })
    },
    primary: {
      enabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.solid({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.solid({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'pressed'
      }),
      selected: opts.solid({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'selected'
      })
    },
    positive: {
      enabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.solid({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.solid({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'pressed'
      }),
      selected: opts.solid({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'selected'
      })
    },
    caution: {
      enabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.solid({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.solid({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'pressed'
      }),
      selected: opts.solid({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'selected'
      })
    },
    critical: {
      enabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.solid({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.solid({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.solid({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'pressed'
      }),
      selected: opts.solid({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'selected'
      })
    }
  };
  var muted = {
    default: {
      enabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.muted({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.muted({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'pressed'
      }),
      selected: opts.muted({
        base: base,
        dark: dark,
        tone: 'default',
        name: name,
        state: 'selected'
      })
    },
    transparent: {
      enabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.muted({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.muted({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'pressed'
      }),
      selected: opts.muted({
        base: base,
        dark: dark,
        tone: 'transparent',
        name: name,
        state: 'selected'
      })
    },
    primary: {
      enabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.muted({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.muted({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'pressed'
      }),
      selected: opts.muted({
        base: base,
        dark: dark,
        tone: 'primary',
        name: name,
        state: 'selected'
      })
    },
    positive: {
      enabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.muted({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.muted({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'pressed'
      }),
      selected: opts.muted({
        base: base,
        dark: dark,
        tone: 'positive',
        name: name,
        state: 'selected'
      })
    },
    caution: {
      enabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.muted({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.muted({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'pressed'
      }),
      selected: opts.muted({
        base: base,
        dark: dark,
        tone: 'caution',
        name: name,
        state: 'selected'
      })
    },
    critical: {
      enabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'enabled'
      }),
      disabled: opts.muted({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'disabled'
      }),
      hovered: opts.muted({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'hovered'
      }),
      pressed: opts.muted({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'pressed'
      }),
      selected: opts.muted({
        base: base,
        dark: dark,
        tone: 'critical',
        name: name,
        state: 'selected'
      })
    }
  };
  var card = {
    enabled: opts.card({
      base: base,
      dark: dark,
      name: name,
      state: 'enabled',
      solid: solid.default,
      muted: muted.default
    }),
    disabled: opts.card({
      base: base,
      dark: dark,
      name: name,
      state: 'disabled',
      solid: solid.default,
      muted: muted.default
    }),
    hovered: opts.card({
      base: base,
      dark: dark,
      name: name,
      state: 'hovered',
      solid: solid.default,
      muted: muted.default
    }),
    pressed: opts.card({
      base: base,
      dark: dark,
      name: name,
      state: 'pressed',
      solid: solid.default,
      muted: muted.default
    }),
    selected: opts.card({
      base: base,
      dark: dark,
      name: name,
      state: 'selected',
      solid: solid.default,
      muted: muted.default
    })
  };
  var button = {
    default: {
      default: opts.button({
        base: base,
        dark: dark,
        mode: 'default',
        solid: solid.default,
        muted: muted.default
      }),
      primary: opts.button({
        base: base,
        dark: dark,
        solid: solid.primary,
        muted: muted.primary,
        mode: 'default'
      }),
      positive: opts.button({
        base: base,
        dark: dark,
        solid: solid.positive,
        muted: muted.positive,
        mode: 'default'
      }),
      caution: opts.button({
        base: base,
        dark: dark,
        solid: solid.caution,
        muted: muted.caution,
        mode: 'default'
      }),
      critical: opts.button({
        base: base,
        dark: dark,
        solid: solid.critical,
        muted: muted.critical,
        mode: 'default'
      })
    },
    ghost: {
      default: opts.button({
        base: base,
        dark: dark,
        solid: solid.default,
        muted: muted.default,
        mode: 'ghost'
      }),
      primary: opts.button({
        base: base,
        dark: dark,
        solid: solid.primary,
        muted: muted.primary,
        mode: 'ghost'
      }),
      positive: opts.button({
        base: base,
        dark: dark,
        solid: solid.positive,
        muted: muted.positive,
        mode: 'ghost'
      }),
      caution: opts.button({
        base: base,
        dark: dark,
        solid: solid.caution,
        muted: muted.caution,
        mode: 'ghost'
      }),
      critical: opts.button({
        base: base,
        dark: dark,
        solid: solid.critical,
        muted: muted.critical,
        mode: 'ghost'
      })
    },
    bleed: {
      default: opts.button({
        base: base,
        dark: dark,
        solid: solid.default,
        muted: muted.default,
        mode: 'bleed'
      }),
      primary: opts.button({
        base: base,
        dark: dark,
        solid: solid.primary,
        muted: muted.primary,
        mode: 'bleed'
      }),
      positive: opts.button({
        base: base,
        dark: dark,
        solid: solid.positive,
        muted: muted.positive,
        mode: 'bleed'
      }),
      caution: opts.button({
        base: base,
        dark: dark,
        solid: solid.caution,
        muted: muted.caution,
        mode: 'bleed'
      }),
      critical: opts.button({
        base: base,
        dark: dark,
        solid: solid.critical,
        muted: muted.critical,
        mode: 'bleed'
      })
    }
  };
  var spot = {
    gray: opts.spot({
      base: base,
      dark: dark,
      key: 'gray'
    }),
    blue: opts.spot({
      base: base,
      dark: dark,
      key: 'blue'
    }),
    purple: opts.spot({
      base: base,
      dark: dark,
      key: 'purple'
    }),
    magenta: opts.spot({
      base: base,
      dark: dark,
      key: 'magenta'
    }),
    red: opts.spot({
      base: base,
      dark: dark,
      key: 'red'
    }),
    orange: opts.spot({
      base: base,
      dark: dark,
      key: 'orange'
    }),
    yellow: opts.spot({
      base: base,
      dark: dark,
      key: 'yellow'
    }),
    green: opts.spot({
      base: base,
      dark: dark,
      key: 'green'
    }),
    cyan: opts.spot({
      base: base,
      dark: dark,
      key: 'cyan'
    })
  };
  var input = {
    default: {
      enabled: opts.input({
        base: base,
        dark: dark,
        mode: 'default',
        state: 'enabled',
        solid: solid.default,
        muted: muted.default
      }),
      disabled: opts.input({
        base: base,
        dark: dark,
        mode: 'default',
        state: 'disabled',
        solid: solid.default,
        muted: muted.default
      }),
      hovered: opts.input({
        base: base,
        dark: dark,
        mode: 'default',
        state: 'hovered',
        solid: solid.default,
        muted: muted.default
      })
    },
    invalid: {
      enabled: opts.input({
        base: base,
        dark: dark,
        mode: 'invalid',
        state: 'enabled',
        solid: solid.default,
        muted: muted.default
      }),
      disabled: opts.input({
        base: base,
        dark: dark,
        mode: 'invalid',
        state: 'disabled',
        solid: solid.default,
        muted: muted.default
      }),
      hovered: opts.input({
        base: base,
        dark: dark,
        mode: 'invalid',
        state: 'hovered',
        solid: solid.default,
        muted: muted.default
      })
    }
  };
  var syntax = opts.syntax({
    base: base,
    dark: dark
  });
  return {
    base: base,
    button: button,
    card: card,
    dark: dark,
    input: input,
    spot: spot,
    syntax: syntax,
    solid: solid,
    muted: muted
  };
}